import React from 'react';
import { Field } from '../Form';
import { renderFields, FormExtensionContext } from '../formUtils';

/**
 * ConditionalWrapper - A reusable component that conditionally applies styling based on an enabled state
 * Useful for graying out form sections when they are disabled
 */
const ConditionalWrapper = ({
  enabled = true,
  children,
  className = '',
  values,
  setFieldValue,
  touched,
  errors,
}) => {
  const {
    customFieldPropsAreEqual,
    customLeafFieldNames,
    customContainerChildrenPropsEqual,
    customContainerValuesEqual,
  } = React.useContext(FormExtensionContext);

  return (
    <div
      className={`${enabled ? '' : 'pointer-events-none [&_input]:opacity-50 [&_select]:opacity-50 [&_label]:opacity-50 [&_img]:opacity-50 [&_.rounded-full]:opacity-50 [&_h3]:opacity-50 [&_h4]:opacity-50 [&_h5]:opacity-50 [&_span]:opacity-50 [&_p]:opacity-50'} ${className}`}
    >
      {Array.isArray(children)
        ? renderFields({ fields: children, values, setFieldValue, touched })
            .filter(Boolean)
            .map((field, index) => (
              <Field
                key={field.name || field.id || `cw-${index}`}
                field={{
                  ...field,
                  visible: field.visible,
                  noMargin:
                    field.noMargin !== undefined ? field.noMargin : index === children.length - 1,
                }}
                values={values}
                setFieldValue={setFieldValue}
                inputClassName=""
                errors={errors}
                touched={touched}
                customFieldPropsAreEqual={customFieldPropsAreEqual}
                customLeafFieldNames={customLeafFieldNames}
                customContainerChildrenPropsEqual={customContainerChildrenPropsEqual}
                customContainerValuesEqual={customContainerValuesEqual}
              />
            ))
        : children}
    </div>
  );
};

export default ConditionalWrapper;
